"use strict";
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
var traverseSchema_1 = require("./traverseSchema");
var setDeepValue_1 = require("./setDeepValue");
function createApi(shouldDebug, dataLayer, initialDebugMessage) {
    if (shouldDebug) {
        console.groupCollapsed('react-data-layer', "[" + initialDebugMessage + "]");
        console.log(JSON.stringify(dataLayer, null, 2));
        console.groupEnd();
    }
    return function api(values, debugMessage) {
        if (debugMessage === void 0) { debugMessage = 'DataLayer.useApi()'; }
        var updatedValues = [];
        var ignoredValues = [];
        var updateFn = function () {
            return traverseSchema_1.traverseSchema(values, {
                onValue: function (keyPath, value) {
                    var didUpdate = typeof value === 'string' && setDeepValue_1.setDeepValue(dataLayer, keyPath, value);
                    var targetArray = didUpdate ? updatedValues : ignoredValues;
                    targetArray.push(keyPath.join('.') + " = " + value);
                },
            });
        };
        if (!shouldDebug) {
            return updateFn();
        }
        console.groupCollapsed('react-data-layer', "[" + debugMessage + "]");
        // Read state before update
        console.groupCollapsed('Before update');
        console.log(JSON.stringify(dataLayer, null, 2));
        console.groupEnd();
        console.groupCollapsed('Fire update');
        console.log(JSON.stringify(values, null, 2));
        console.groupEnd();
        // Fire the actual update
        updateFn();
        console.groupCollapsed(updatedValues.length + " updated values (old != new)");
        updatedValues.forEach(function (string) { return console.log(string); });
        console.groupEnd();
        console.groupCollapsed(ignoredValues.length + " ignored values");
        ignoredValues.forEach(function (string) { return console.log(string); });
        console.groupEnd();
        // Read state after the update.
        console.groupCollapsed('After update');
        console.log(JSON.stringify(dataLayer, null, 2));
        console.groupEnd();
        console.groupEnd();
    };
}
exports.createApi = createApi;
